import styled, { css } from 'styled-components';

import { screens } from 'ggApp/utils/mixins/screens';
import WhiteCheck from './images/checkWhite.svg';

export const NavigationList = styled.div`
    @media (${screens.phone}) and (${screens.desktopMax}) {
        flex: 1;
    }
`;

export const List = styled.div`
    padding-top: 35px;

    @media (${screens.phone}) and (${screens.desktopMax}) {
        margin: 0 10px;
        padding-top: 0;
    }
`;

export const Item = styled.div`
    padding: 0 45px;
    min-height: 90px;
    display: flex;
    flex-direction: column;
    color: #fff;
    font-size: 16px;
    letter-spacing: 0.3px;
    line-height: 1.35;
    position: relative;
    opacity: 0.3;

    &:after {
        content: ' ';
        display: block;
        position: absolute;
        top: -30px;
        left: -30px;
        width: 0;
        height: 0;
        border-top: 45px solid transparent;
        border-right: ${({ theme }) => `30px solid ${theme.colors.secondary}`};
        border-bottom: 45px solid transparent;
        opacity: 0;
        transform: translate3d(30px, 0, 0);
        z-index: -1;
        transition: all 0.4s ease;
    }

    &:before {
        width: 3px;
        position: absolute;
        content: ' ';
        display: block;
        height: 100%;
        left: 49.5px;
        top: 7px;
        opacity: 1;
        transition: all 0.2s ease;
        z-index: 1;
    }

    ${({ passed }) => passed && css`
        opacity: 1;
        &:before {
            background: #fff;
        }
    `}

    ${({ passedLast }) => passedLast && css`
        &:before {
            background: #fff;
        }
    `}

    ${({ active }) => active && css`
        opacity: 1;

        &:after {
            opacity: 1;
            transform: translate3d(0, 0, 0);
        }
    `}

    @media (${screens.phone}) and (${screens.desktopMax}) {
        font-size: 14px;
        min-height: 75px;
        &:after {
            display: none;
        }
        &:last-child {
            min-height: 0;
        }
    }
`;

export const Name = styled.div`
    position: relative;
    padding-left: 30px;

    &:after {
        content: ' ';
        display: block;
        width: 12px;
        height: 12px;
        position: absolute;
        border: 3px solid #fff;
        border-radius: 50%;
        background: #fff;
        left: 0;
        top: 6px;
        z-index: 2;
        transition: all 0.2s ease;
    }

    ${({ passed }) => passed && css`
        color: rgba(#fff, 0.75);

        &:after {
            width: 26px;
            height: 26px;
            top: -1px;
            left: -7px;
            border: none;
            background: transparent;
            background-image: url(${WhiteCheck});
            background-position: 3px 50%;
            background-repeat: no-repeat;
            background-size: 21px auto;
        }
    `}

    ${({ active }) => active && css`
        &:after {
            width: 20px;
            height: 20px;
            top: 2px;
            left: -4px;
            background: ${({ theme }) => theme.colors.secondary};
        }
    `}

    @media (${screens.phone}) and (${screens.desktopMax}) {
        &:after {
            top: 3px;
        }

        ${({ active }) => active && css`
            &:after {
                top: -1px;
            }
        `}

        ${({ passed }) => passed && css`
            &:after {
                top: -3px;
            }
        `}
    }
`;

export const Description = styled.div`
    padding-left: 30px;
    margin-top: 5px;
    font-size: 16px;
    letter-spacing: 0.3px;
    font-weight: 300;
    margin-bottom: 15px;

    ${({ passed }) => passed && css`
        color: rgba(#fff, 0.75);
    `}

    @media (${screens.phone}) and (${screens.desktopMax}) {
        font-size: 14px;
    }
`;

export const DescriptionValue = styled.div`
    &:nth-child(3) {
        margin-bottom: 15px;
    }
`;
